interface PackagesProps {
  onOpenConsultation: () => void;
}

const packages = [
  {
    name: "Start",
    tag: "Model abonamentowy",
    subtitle: "Lokalny elektryk, hydraulik, usługi",
    price: "299",
    period: "mies",
    features: [
      "Strona www (do 5 sekcji)",
      "Formularz kontaktowy",
      "SEO lokalne podstawowe",
      "Podpięcie domeny klienta",
      "Hosting + aktualizacje",
      "Mobile 100%",
    ],
    cta: "Napisz ofertę dla pakietu Start",
    highlighted: false,
  },
  {
    name: "Firma",
    tag: "Najpopularniejszy",
    subtitle: "Wiaty, ogrodzenia, carporty, na wymiar",
    price: "499",
    period: "mies",
    features: [
      "Wszystko z pakietu Start",
      "Panel CRM z historią leadów",
      "Automatyzacja FB/IG → panel",
      "Kalkulator / konfigurator online",
      "Generowanie ofert PDF",
      "SEO lokalne rozbudowane",
    ],
    cta: "Napisz ofertę dla pakietu Firma",
    highlighted: true,
  },
  {
    name: "Pro",
    tag: "Kompleksowy system sprzedaży online",
    subtitle: "Kompleksowy system sprzedaży online",
    price: "899",
    period: "mies",
    features: [
      "Wszystko z pakietu Firma",
      "Wizualizator 3D produktu",
      "Social media (2 posty / tyg)",
      "Montaż video / reels",
      "Priorytetowe wsparcie",
      "Raport miesięczny",
    ],
    cta: "Napisz ofertę dla pakietu Pro",
    highlighted: false,
  },
];

const addons = [
  { name: "Wizualizator 3D", price: "od 800 zł" },
  { name: "Konfigurator / kalkulator", price: "od 500 zł" },
  { name: "Generowanie ofert PDF", price: "od 400 zł" },
  { name: "Integracja Make.com", price: "od 300 zł" },
  { name: "Montaż video (1 film)", price: "od 200 zł" },
  { name: "Sesja zdjęciowa produktów", price: "wycena indywidualna" },
];

const PackagesSection = ({ onOpenConsultation }: PackagesProps) => {
  return (
    <section id="pakiety" className="py-20 lg:py-28 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-[#0F2557] text-sm font-semibold tracking-wide uppercase mb-3">
            Cennik
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1A1A2E] mb-5">
            Model abonamentowy — płacisz miesięcznie, masz wszystko
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed">
            Bez ukrytych kosztów. Hosting, aktualizacje i wsparcie w cenie abonamentu.
          </p>
        </div>

        {/* Packages grid */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 items-start mb-16">
          {packages.map((pkg) => (
            <div
              key={pkg.name}
              className={`rounded-xl p-7 flex flex-col gap-6 border transition-all ${
                pkg.highlighted
                  ? "bg-[#0F2557] border-[#0F2557] text-white lg:scale-105"
                  : "bg-white border-gray-100 text-[#1A1A2E]"
              }`}
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span
                    className={`text-xs font-semibold px-3 py-1 rounded-full ${
                      pkg.highlighted
                        ? "bg-white/20 text-white"
                        : "bg-[#0F2557]/10 text-[#0F2557]"
                    }`}
                  >
                    {pkg.tag}
                  </span>
                </div>
                <h3
                  className={`text-2xl font-bold mb-1 ${
                    pkg.highlighted ? "text-white" : "text-[#1A1A2E]"
                  }`}
                >
                  {pkg.name}
                </h3>
                <p
                  className={`text-sm leading-relaxed mb-4 ${
                    pkg.highlighted ? "text-white/60" : "text-gray-400"
                  }`}
                >
                  {pkg.subtitle}
                </p>
                <div className="flex items-end gap-1">
                  <span
                    className={`text-4xl font-extrabold ${
                      pkg.highlighted ? "text-white" : "text-[#1A1A2E]"
                    }`}
                  >
                    {pkg.price} zł
                  </span>
                  <span
                    className={`text-sm mb-1.5 ${
                      pkg.highlighted ? "text-white/60" : "text-gray-400"
                    }`}
                  >
                    / {pkg.period}
                  </span>
                </div>
              </div>

              <ul className="flex flex-col gap-2.5 flex-1">
                {pkg.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i
                        className={`ri-check-line text-base font-bold ${
                          pkg.highlighted ? "text-[#4A7FD4]" : "text-[#0F2557]"
                        }`}
                      ></i>
                    </div>
                    <span className={pkg.highlighted ? "text-white/80" : "text-gray-600"}>
                      {f}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                onClick={onOpenConsultation}
                className={`whitespace-nowrap w-full py-3 rounded-md font-semibold text-sm transition-all cursor-pointer ${
                  pkg.highlighted
                    ? "bg-white text-[#0F2557] hover:bg-gray-100"
                    : "bg-[#0F2557] text-white hover:bg-[#1B3D7A]"
                }`}
              >
                {pkg.cta} ↗
              </button>
            </div>
          ))}
        </div>

        {/* Addons */}
        <div className="bg-white rounded-xl border border-gray-100 p-8 mb-10">
          <h3 className="text-xl font-bold text-[#1A1A2E] mb-2">Dodatki jednorazowe</h3>
          <p className="text-gray-400 text-sm mb-6">Rozszerz swoją stronę o konkretne funkcje — bez abonamentu.</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {addons.map((addon) => (
              <div
                key={addon.name}
                className="flex items-center justify-between bg-[#F7F8FA] rounded-lg px-4 py-3"
              >
                <div className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-add-circle-line text-[#0F2557] text-base"></i>
                  </div>
                  <span className="text-sm font-medium text-[#1A1A2E]">{addon.name}</span>
                </div>
                <span className="text-sm font-semibold text-[#0F2557] whitespace-nowrap ml-3">{addon.price}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Code buyout option */}
        <div className="bg-[#1A1A2E] rounded-xl p-8 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-code-s-slash-line text-white/60 text-base"></i>
              </div>
              <span className="text-white/60 text-sm font-semibold uppercase tracking-wide">Opcja wykupu kodu</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-1">Dla klientów, którzy chcą pełnej własności</h3>
            <p className="text-white/50 text-sm">Jednorazowo + hosting klienta we własnym zakresie</p>
          </div>
          <div className="flex flex-col items-start lg:items-end gap-3 flex-shrink-0">
            <div className="text-3xl font-extrabold text-white">2 000 – 5 000 zł</div>
            <button
              onClick={onOpenConsultation}
              className="whitespace-nowrap bg-white text-[#1A1A2E] px-6 py-2.5 rounded-md font-semibold text-sm hover:bg-gray-100 transition-all cursor-pointer"
            >
              Zapytaj o wycenę ↗
            </button>
          </div>
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Nie wiesz, który pakiet wybrać? Napisz — pomogę dobrać odpowiedni zakres dla Twojej firmy.
        </p>
      </div>
    </section>
  );
};

export default PackagesSection;
